import { useState, useCallback } from 'react';
import ReportsService from '@/services/reportsService';
import { toast } from 'react-hot-toast';

const useRevenueSummary = (initialFilters = {}) => {
  const [data, setData] = useState([]);
  const [summary, setSummary] = useState(null);
  const [branchSummary, setBranchSummary] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [filters, setFilters] = useState({
    branchId: initialFilters.branchId ?? null,
    period: initialFilters.period ?? null,
    startDate: initialFilters.startDate ?? null,
    endDate: initialFilters.endDate ?? null,
    offset: initialFilters.offset ?? 0,
    limit: initialFilters.limit ?? 25,
  });

  const fetchRevenueSummary = useCallback(async (overrideFilters) => {
    try {
      setLoading(true);
      setError(null);

      const finalFilters = overrideFilters ?? filters;

      const response =
        await ReportsService.getRevenueSummary(finalFilters);

      setData(response?.data ?? []);
      setSummary(response?.summary ?? response?.data?.summary ?? null);
      setBranchSummary(response?.branchSummary ?? []);
      setTotal(response?.total ?? response?.data?.total ?? 0);

    } catch (err) {
      console.error(err);
      setError('Failed to load revenue summary');
      toast.error('Failed to load revenue summary');
    } finally {
      setLoading(false);
    }
  }, [filters]);

  return {
    data,
    summary,
    branchSummary,
    total,
    loading,
    error,
    filters,
    setFilters,
    fetchRevenueSummary,
  };
};

export default useRevenueSummary;
